export enum CountryNames {
  ANDORRA = "Andorra",
  UNITED_ARAB_EMIRATES = "United Arab Emirates",
  AFGHANISTAN = "Afghanistan",
  ANTIGUA_AND_BARBUDA = "Antigua and Barbuda",
  ANGUILLA = "Anguilla",
  ALBANIA = "Albania",
  ARMENIA = "Armenia",
  ANGOLA = "Angola",
  ANTARCTICA = "Antarctica",
  ARGENTINA = "Argentina",
  AMERICAN_SAMOA = "American Samoa",
  AUSTRIA = "Austria",
  AUSTRALIA = "Australia",
  ARUBA = "Aruba",
  ALAND_ISLANDS = "Aland Islands",
  AZERBAIJAN = "Azerbaijan",
  BOSNIA_AND_HERZEGOVINA = "Bosnia and Herzegovina",
  BARBADOS = "Barbados",
  BANGLADESH = "Bangladesh",
  BELGIUM = "Belgium",
  BURKINA_FASO = "Burkina Faso",
  BULGARIA = "Bulgaria",
  BAHRAIN = "Bahrain",
  BURUNDI = "Burundi",
  BENIN = "Benin",
  SAINT_BARTHELEMY = "Saint Barthélemy",
  BERMUDA = "Bermuda",
  BRUNEI_DARUSSALAM = "Brunei Darussalam",
  BOLIVIA = "Bolivia",
  BONAIRE_SAINT_EUSTATIUS_AND_SABA = "Bonaire, Saint Eustatius and Saba",
  BRAZIL = "Brazil",
  BAHAMAS = "Bahamas",
  BHUTAN = "Bhutan",
  BOUVET_ISLAND = "Bouvet Island",
  BOTSWANA = "Botswana",
  BELARUS = "Belarus",
  BELIZE = "Belize",
  CANADA = "Canada",
  COCOS_ISLANDS = "Cocos (Keeling) Islands",
  CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE = "Congo, the Democratic Republic of the",
  CENTRAL_AFRICAN_REPUBLIC = "Central African Republic",
  CONGO = "Congo",
  SWITZERLAND = "Switzerland",
  COTE_D_IVOIRE = "Cote d'Ivoire",
  COOK_ISLANDS = "Cook Islands",
  CHILE = "Chile",
  CAMEROON = "Cameroon",
  CHINA = "China",
  COLOMBIA = "Colombia",
  COSTA_RICA = "Costa Rica",
  CUBA = "Cuba",
  CAPE_VERDE = "Cape Verde",
  CURAÇAO = "Curaçao",
  CHRISTMAS_ISLAND = "Christmas Island",
  CYPRUS = "Cyprus",
  CZECH_REPUBLIC = "Czech Republic",
  GERMANY = "Germany",
  DJIBOUTI = "Djibouti",
  DENMARK = "Denmark",
  DOMINICA = "Dominica",
  DOMINICAN_REPUBLIC = "Dominican Republic",
  ALGERIA = "Algeria",
  ECUADOR = "Ecuador",
  ESTONIA = "Estonia",
  EGYPT = "Egypt",
  WESTERN_SAHARA = "Western Sahara",
  ERITREA = "Eritrea",
  SPAIN = "Spain",
  ETHIOPIA = "Ethiopia",
  FINLAND = "Finland",
  FIJI = "Fiji",
  FALKLAND_ISLANDS = "Falkland Islands",
  MICRONESIA_FEDERATED_STATES_OF = "Micronesia, Federated States of",
  FAROE_ISLANDS = "Faroe Islands",
  FRANCE = "France",
  GABON = "Gabon",
  UNITED_KINGDOM = "United Kingdom",
  GRENADA = "Grenada",
  GEORGIA = "Georgia",
  FRENCH_GUIANA = "French Guiana",
  GUERNSEY = "Guernsey",
  GHANA = "Ghana",
  GIBRALTAR = "Gibraltar",
  GREENLAND = "Greenland",
  GAMBIA = "Gambia",
  GUINEA = "Guinea",
  GUADELOUPE = "Guadeloupe",
  EQUATORIAL_GUINEA = "Equatorial Guinea",
  GREECE = "Greece",
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS = "South Georgia and the South Sandwich Islands",
  GUATEMALA = "Guatemala",
  GUAM = "Guam",
  GUINEA_BISSAU = "Guinea-Bissau",
  GUYANA = "Guyana",
  HONG_KONG = "Hong Kong",
  HEARD_ISLAND_AND_MCDONALD_ISLANDS = "Heard Island and McDonald Islands",
  HONDURAS = "Honduras",
  CROATIA = "Croatia",
  HAITI = "Haiti",
  HUNGARY = "Hungary",
  INDONESIA = "Indonesia",
  IRELAND = "Ireland",
  ISRAEL = "Israel",
  ISLE_OF_MAN = "Isle of Man",
  INDIA = "India",
  BRITISH_INDIAN_OCEAN_TERRITORY = "British Indian Ocean Territory",
  IRAQ = "Iraq",
  IRAN = "Iran",
  ICELAND = "Iceland",
  ITALY = "Italy",
  JERSEY = "Jersey",
  JAMAICA = "Jamaica",
  JORDAN = "Jordan",
  JAPAN = "Japan",
  KENYA = "Kenya",
  KYRGYZSTAN = "Kyrgyzstan",
  CAMBODIA = "Cambodia",
  KIRIBATI = "Kiribati",
  COMOROS = "Comoros",
  SAINT_KITTS_AND_NEVIS = "Saint Kitts and Nevis",
  KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF = "Korea, Democratic People's Republic of",
  KOREA_REPUBLIC_OF = "Korea, Republic of",
  KUWAIT = "Kuwait",
  CAYMAN_ISLANDS = "Cayman Islands",
  KAZAKHSTAN = "Kazakhstan",
  LAO_PEOPLES_DEMOCRATIC_REPUBLIC = "Lao People's Democratic Republic",
  LEBANON = "Lebanon",
  SAINT_LUCIA = "Saint Lucia",
  LIECHTENSTEIN = "Liechtenstein",
  SRI_LANKA = "Sri Lanka",
  LIBERIA = "Liberia",
  LESOTHO = "Lesotho",
  LITHUANIA = "Lithuania",
  LUXEMBOURG = "Luxembourg",
  LATVIA = "Latvia",
  LIBYAN_ARAB_JAMAHIRIYA = "Libyan Arab Jamahiriya",
  MOROCCO = "Morocco",
  MONACO = "Monaco",
  MOLDOVA = "Moldova",
  MONTENEGRO = "Montenegro",
  SAINT_MARTIN_FRENCH_PART = "Saint Martin (French part)",
  MADAGASCAR = "Madagascar",
  MARSHALL_ISLANDS = "Marshall Islands",
  MACEDONIA = "Macedonia",
  MALI = "Mali",
  MYANMAR = "Myanmar",
  MONGOLIA = "Mongolia",
  MACAO = "Macao",
  NORTHERN_MARIANA_ISLANDS = "Northern Mariana Islands",
  MARTINIQUE = "Martinique",
  MAURITANIA = "Mauritania",
  MONTSERRAT = "Montserrat",
  MALTA = "Malta",
  MAURITIUS = "Mauritius",
  MALDIVES = "Maldives",
  MALAWI = "Malawi",
  MEXICO = "Mexico",
  MALAYSIA = "Malaysia",
  MOZAMBIQUE = "Mozambique",
  NAMIBIA = "Namibia",
  NEW_CALEDONIA = "New Caledonia",
  NIGER = "Niger",
  NORFOLK_ISLAND = "Norfolk Island",
  NIGERIA = "Nigeria",
  NICARAGUA = "Nicaragua",
  NETHERLANDS = "Netherlands",
  NORWAY = "Norway",
  NEPAL = "Nepal",
  NAURU = "Nauru",
  NIUE = "Niue",
  NEW_ZEALAND = "New Zealand",
  OMAN = "Oman",
  PANAMA = "Panama",
  PERU = "Peru",
  FRENCH_POLYNESIA = "French Polynesia",
  PAPUA_NEW_GUINEA = "Papua New Guinea",
  PHILIPPINES = "Philippines",
  PAKISTAN = "Pakistan",
  POLAND = "Poland",
  SAINT_PIERRE_AND_MIQUELON = "Saint Pierre and Miquelon",
  PITCAIRN = "Pitcairn",
  PUERTO_RICO = "Puerto Rico",
  PALESTINIAN_TERRITORY = "Palestinian Territory",
  PORTUGAL = "Portugal",
  PALAU = "Palau",
  PARAGUAY = "Paraguay",
  QATAR = "Qatar",
  REUNION = "Reunion",
  ROMANIA = "Romania",
  SERBIA = "Serbia",
  RUSSIAN_FEDERATION = "Russian Federation",
  RWANDA = "Rwanda",
  SAUDI_ARABIA = "Saudi Arabia",
  SOLOMON_ISLANDS = "Solomon Islands",
  SEYCHELLES = "Seychelles",
  SUDAN = "Sudan",
  SWEDEN = "Sweden",
  SINGAPORE = "Singapore",
  SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA = "Saint Helena, Ascension and Tristan da Cunha",
  SLOVENIA = "Slovenia",
  SVALBARD_AND_JAN_MAYEN = "Svalbard and Jan Mayen",
  SLOVAKIA = "Slovakia",
  SIERRA_LEONE = "Sierra Leone",
  SAN_MARINO = "San Marino",
  SENEGAL = "Senegal",
  SOMALIA = "Somalia",
  SURINAME = "Suriname",
  SAO_TOME_AND_PRINCIPE = "Sao Tome and Principe",
  EL_SALVADOR = "El Salvador",
  SINT_MAARTEN_DUTCH_PART = "Sint Maarten (Dutch part)",
  SYRIAN_ARAB_REPUBLIC = "Syrian Arab Republic",
  SWAZILAND = "Swaziland",
  TURKS_AND_CAICOS_ISLANDS = "Turks and Caicos Islands",
  CHAD = "Chad",
  FRENCH_SOUTHERN_TERRITORIES = "French Southern Territories",
  TOGO = "Togo",
  THAILAND = "Thailand",
  TAJIKISTAN = "Tajikistan",
  TOKELAU = "Tokelau",
  TIMOR_LESTE = "Timor-Leste",
  TURKMENISTAN = "Turkmenistan",
  TUNISIA = "Tunisia",
  TONGA = "Tonga",
  TURKEY = "Turkey",
  TRINIDAD_AND_TOBAGO = "Trinidad and Tobago",
  TUVALU = "Tuvalu",
  TAIWAN = "Taiwan",
  TANZANIA = "Tanzania",
  UKRAINE = "Ukraine",
  UGANDA = "Uganda",
  UNITED_STATES_MINOR_OUTLYING_ISLANDS = "United States Minor Outlying Islands",
  UNITED_STATES = "United States",
  URUGUAY = "Uruguay",
  UZBEKISTAN = "Uzbekistan",
  HOLY_SEE_VATICAN_CITY_STATE = "Holy See (Vatican City State)",
  SAINT_VINCENT_AND_THE_GRENADINES = "Saint Vincent and the Grenadines",
  VENEZUELA = "Venezuela",
  VIRGIN_ISLANDS_BRITISH = "Virgin Islands, British",
  VIRGIN_ISLANDS_US = "Virgin Islands, U.S.",
  VIET_NAM = "Viet Nam",
  VANUATU = "Vanuatu",
  WALLIS_AND_FUTUNA = "Wallis and Futuna",
  SAMOA = "Samoa",
  YEMEN = "Yemen",
  MAYOTTE = "Mayotte",
  SOUTH_AFRICA = "South Africa",
  ZAMBIA = "Zambia",
  ZIMBABWE = "Zimbabwe",
}

export enum CountryCode {
  ANDORRA = "AD",
  UNITED_ARAB_EMIRATES = "AE",
  AFGHANISTAN = "AF",
  ANTIGUA_AND_BARBUDA = "AG",
  ANGUILLA = "AI",
  ALBANIA = "AL",
  ARMENIA = "AM",
  ANGOLA = "AO",
  ANTARCTICA = "AQ",
  ARGENTINA = "AR",
  AMERICAN_SAMOA = "AS",
  AUSTRIA = "AT",
  AUSTRALIA = "AU",
  ARUBA = "AW",
  ALAND_ISLANDS = "AX",
  AZERBAIJAN = "AZ",
  BOSNIA_AND_HERZEGOVINA = "BA",
  BARBADOS = "BB",
  BANGLADESH = "BD",
  BELGIUM = "BE",
  BURKINA_FASO = "BF",
  BULGARIA = "BG",
  BAHRAIN = "BH",
  BURUNDI = "BI",
  BENIN = "BJ",
  SAINT_BARTHELEMY = "BL",
  BERMUDA = "BM",
  BRUNEI_DARUSSALAM = "BN",
  BOLIVIA = "BO",
  BONAIRE_SAINT_EUSTATIUS_AND_SABA = "BQ",
  BRAZIL = "BR",
  BAHAMAS = "BS",
  BHUTAN = "BT",
  BOUVET_ISLAND = "BV",
  BOTSWANA = "BW",
  BELARUS = "BY",
  BELIZE = "BZ",
  CANADA = "CA",
  COCOS_ISLANDS = "CC",
  CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE = "CD",
  CENTRAL_AFRICAN_REPUBLIC = "CF",
  CONGO = "CG",
  SWITZERLAND = "CH",
  COTE_D_IVOIRE = "CI",
  COOK_ISLANDS = "CK",
  CHILE = "CL",
  CAMEROON = "CM",
  CHINA = "CN",
  COLOMBIA = "CO",
  COSTA_RICA = "CR",
  CUBA = "CU",
  CAPE_VERDE = "CV",
  CURAÇAO = "CW",
  CHRISTMAS_ISLAND = "CX",
  CYPRUS = "CY",
  CZECH_REPUBLIC = "CZ",
  GERMANY = "DE",
  DJIBOUTI = "DJ",
  DENMARK = "DK",
  DOMINICA = "DM",
  DOMINICAN_REPUBLIC = "DO",
  ALGERIA = "DZ",
  ECUADOR = "EC",
  ESTONIA = "EE",
  EGYPT = "EG",
  WESTERN_SAHARA = "EH",
  ERITREA = "ER",
  SPAIN = "ES",
  ETHIOPIA = "ET",
  FINLAND = "FI",
  FIJI = "FJ",
  FALKLAND_ISLANDS = "FK",
  MICRONESIA_FEDERATED_STATES_OF = "FM",
  FAROE_ISLANDS = "FO",
  FRANCE = "FR",
  GABON = "GA",
  UNITED_KINGDOM = "GB",
  GRENADA = "GD",
  GEORGIA = "GE",
  FRENCH_GUIANA = "GF",
  GUERNSEY = "GG",
  GHANA = "GH",
  GIBRALTAR = "GI",
  GREENLAND = "GL",
  GAMBIA = "GM",
  GUINEA = "GN",
  GUADELOUPE = "GP",
  EQUATORIAL_GUINEA = "GQ",
  GREECE = "GR",
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS = "GS",
  GUATEMALA = "GT",
  GUAM = "GU",
  GUINEA_BISSAU = "GW",
  GUYANA = "GY",
  HONG_KONG = "HK",
  HEARD_ISLAND_AND_MCDONALD_ISLANDS = "HM",
  HONDURAS = "HN",
  CROATIA = "HR",
  HAITI = "HT",
  HUNGARY = "HU",
  INDONESIA = "ID",
  IRELAND = "IE",
  ISRAEL = "IL",
  ISLE_OF_MAN = "IM",
  INDIA = "IN",
  BRITISH_INDIAN_OCEAN_TERRITORY = "IO",
  IRAQ = "IQ",
  IRAN = "IR",
  ICELAND = "IS",
  ITALY = "IT",
  JERSEY = "JE",
  JAMAICA = "JM",
  JORDAN = "JO",
  JAPAN = "JP",
  KENYA = "KE",
  KYRGYZSTAN = "KG",
  CAMBODIA = "KH",
  KIRIBATI = "KI",
  COMOROS = "KM",
  SAINT_KITTS_AND_NEVIS = "KN",
  KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF = "KP",
  KOREA_REPUBLIC_OF = "KR",
  KUWAIT = "KW",
  CAYMAN_ISLANDS = "KY",
  KAZAKHSTAN = "KZ",
  LAO_PEOPLES_DEMOCRATIC_REPUBLIC = "LA",
  LEBANON = "LB",
  SAINT_LUCIA = "LC",
  LIECHTENSTEIN = "LI",
  SRI_LANKA = "LK",
  LIBERIA = "LR",
  LESOTHO = "LS",
  LITHUANIA = "LT",
  LUXEMBOURG = "LU",
  LATVIA = "LV",
  LIBYAN_ARAB_JAMAHIRIYA = "LY",
  MOROCCO = "MA",
  MONACO = "MC",
  MOLDOVA = "MD",
  MONTENEGRO = "ME",
  SAINT_MARTIN_FRENCH_PART = "MF",
  MADAGASCAR = "MG",
  MARSHALL_ISLANDS = "MH",
  MACEDONIA = "MK",
  MALI = "ML",
  MYANMAR = "MM",
  MONGOLIA = "MN",
  MACAO = "MO",
  NORTHERN_MARIANA_ISLANDS = "MP",
  MARTINIQUE = "MQ",
  MAURITANIA = "MR",
  MONTSERRAT = "MS",
  MALTA = "MT",
  MAURITIUS = "MU",
  MALDIVES = "MV",
  MALAWI = "MW",
  MEXICO = "MX",
  MALAYSIA = "MY",
  MOZAMBIQUE = "MZ",
  NAMIBIA = "NA",
  NEW_CALEDONIA = "NC",
  NIGER = "NE",
  NORFOLK_ISLAND = "NF",
  NIGERIA = "NG",
  NICARAGUA = "NI",
  NETHERLANDS = "NL",
  NORWAY = "NO",
  NEPAL = "NP",
  NAURU = "NR",
  NIUE = "NU",
  NEW_ZEALAND = "NZ",
  OMAN = "OM",
  PANAMA = "PA",
  PERU = "PE",
  FRENCH_POLYNESIA = "PF",
  PAPUA_NEW_GUINEA = "PG",
  PHILIPPINES = "PH",
  PAKISTAN = "PK",
  POLAND = "PL",
  SAINT_PIERRE_AND_MIQUELON = "PM",
  PITCAIRN = "PN",
  PUERTO_RICO = "PR",
  PALESTINIAN_TERRITORY = "PS",
  PORTUGAL = "PT",
  PALAU = "PW",
  PARAGUAY = "PY",
  QATAR = "QA",
  REUNION = "RE",
  ROMANIA = "RO",
  SERBIA = "RS",
  RUSSIAN_FEDERATION = "RU",
  RWANDA = "RW",
  SAUDI_ARABIA = "SA",
  SOLOMON_ISLANDS = "SB",
  SEYCHELLES = "SC",
  SUDAN = "SD",
  SWEDEN = "SE",
  SINGAPORE = "SG",
  SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA = "SH",
  SLOVENIA = "SI",
  SVALBARD_AND_JAN_MAYEN = "SJ",
  SLOVAKIA = "SK",
  SIERRA_LEONE = "SL",
  SAN_MARINO = "SM",
  SENEGAL = "SN",
  SOMALIA = "SO",
  SURINAME = "SR",
  SAO_TOME_AND_PRINCIPE = "ST",
  EL_SALVADOR = "SV",
  SINT_MAARTEN_DUTCH_PART = "SX",
  SYRIAN_ARAB_REPUBLIC = "SY",
  SWAZILAND = "SZ",
  TURKS_AND_CAICOS_ISLANDS = "TC",
  CHAD = "TD",
  FRENCH_SOUTHERN_TERRITORIES = "TF",
  TOGO = "TG",
  THAILAND = "TH",
  TAJIKISTAN = "TJ",
  TOKELAU = "TK",
  TIMOR_LESTE = "TL",
  TURKMENISTAN = "TM",
  TUNISIA = "TN",
  TONGA = "TO",
  TURKEY = "TR",
  TRINIDAD_AND_TOBAGO = "TT",
  TUVALU = "TV",
  TAIWAN = "TW",
  TANZANIA = "TZ",
  UKRAINE = "UA",
  UGANDA = "UG",
  UNITED_STATES_MINOR_OUTLYING_ISLANDS = "UM",
  UNITED_STATES = "US",
  URUGUAY = "UY",
  UZBEKISTAN = "UZ",
  HOLY_SEE_VATICAN_CITY_STATE = "VA",
  SAINT_VINCENT_AND_THE_GRENADINES = "VC",
  VENEZUELA = "VE",
  VIRGIN_ISLANDS_BRITISH = "VG",
  VIRGIN_ISLANDS_US = "VI",
  VIET_NAM = "VN",
  VANUATU = "VU",
  WALLIS_AND_FUTUNA = "WF",
  SAMOA = "WS",
  YEMEN = "YE",
  MAYOTTE = "YT",
  SOUTH_AFRICA = "ZA",
  ZAMBIA = "ZM",
  ZIMBABWE = "ZW",
}
